import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BookingForm from './BookingForm';
import BookingStatus from './BookingStatus';
import './BookingPage.css';

const BookingPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('book'); // 'book' or 'status'

  return (
    <div className="booking-page">
      <div className="tab-switcher">
        <button
          className={`tab-btn ${activeTab === 'book' ? 'active' : ''}`}
          onClick={() => setActiveTab('book')}
        >
          {t('book_a_room')}
        </button>
        <button
          className={`tab-btn ${activeTab === 'status' ? 'active' : ''}`}
          onClick={() => setActiveTab('status')}
        >
          {t('check_status_tab')}
        </button>
      </div>

      <div className="booking-content">
        <div className={`booking-column ${activeTab === 'book' ? 'active' : ''}`}>
          <BookingForm />
        </div>
        <div className={`booking-column ${activeTab === 'status' ? 'active' : ''}`}>
          <BookingStatus />
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
